const colors = {
    darkBrown: '#222525',
    brown: '#16140E',
    yellow: '#FFD370',
    white: '#FFFFFF',
    lightYellow: '#FFFFDB',
    floralWhite: '#F9F5ED',
    gray: '#f2f4f8',
    black: '#16140E'
};

export default colors;
